import {Button, Menu, MenuItem} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import {translations} from '../../../../../../i18n/translations';
import {useTranslation} from 'react-i18next';
import {useState} from 'react';
import {EntityOccurrenceTypeCategory} from '../../../../../../backend/responses/entity-occurrence';

type OccurrencesTypesAddMenuProps = {
  canWrite: boolean;
  onSelectType: (type: EntityOccurrenceTypeCategory) => void;
};

export default function OccurrencesTypesAddMenu({
  onSelectType,
  canWrite,
}: OccurrencesTypesAddMenuProps) {
  const {t} = useTranslation();
  const [addOccurrencesMenuAnchor, setAddOccurrencesMenuAnchor] = useState<null | HTMLElement>(
    null
  );

  if (!canWrite) {
    return <></>;
  }

  return (
    <>
      <Button
        startIcon={<AddIcon />}
        variant="inverted"
        onClick={(event) => setAddOccurrencesMenuAnchor(event.currentTarget)}
      >
        {t(translations.office.professional_caregiver.settings.occurrences.add)}
      </Button>
      <Menu
        id="add-occurrence-menu"
        className="add-occurrence-menu"
        anchorEl={addOccurrencesMenuAnchor}
        open={addOccurrencesMenuAnchor !== null}
        onClose={() => setAddOccurrencesMenuAnchor(null)}
        transformOrigin={{horizontal: 'right', vertical: 'top'}}
        anchorOrigin={{horizontal: 'right', vertical: 'bottom'}}
      >
        <MenuItem
          key="occurences-group-option-patients"
          onClick={() => {
            setAddOccurrencesMenuAnchor(null);

            onSelectType('patients');
          }}
          value="patients"
          className="occurrences-menu-item"
        >
          {`${t(translations.office.professional_caregiver.settings.occurrences.occurrence)} ${t(
            translations.office.professional_caregiver.settings.occurrences.patients
          ).toLowerCase()}`}
        </MenuItem>
        <MenuItem
          key="occurences-group-option-general"
          onClick={() => {
            setAddOccurrencesMenuAnchor(null);
            onSelectType('general');
          }}
          value="general"
          className="occurrences-menu-item"
        >
          {`${t(translations.office.professional_caregiver.settings.occurrences.occurrence)} ${t(
            translations.office.professional_caregiver.settings.occurrences.general
          ).toLowerCase()}`}
        </MenuItem>
      </Menu>
    </>
  );
}
